module.exports = __webpack_public_path__ + "static/media/tzuk_farm_thumb_even.c5aea3fe.jpg";